/**
 * Created by Ning Jiang on 7/10/2019.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {Timeline, TimelineLite} from "gsap";
import {PixiesVsPiratesParsedGameData} from "../../server/parseddata/PixiesVsPiratesParsedGameData";
import {PPScatterSymbol} from "../../symbols/PPScatterSymbol";

export class PPScatterWPController extends WinPresentationController {

    private _timeline:TimelineLite | null;
    private _freespinTriggered:boolean;
    private _freespinRound:number;
    private _scatterPositions:number[];

    constructor(indexes:[number, number]) {
        super(indexes, {name : "Scatters", skippable : false});
    }

    protected parseFeatureGameData(data:PixiesVsPiratesParsedGameData):void {
        this._freespinTriggered = data.freespinTriggeredThisSpin;
        this._freespinRound = data.freespinRound;
        this._scatterPositions = data.scatterPositions!;
    }

    protected hasWin():boolean {
        return this._freespinTriggered && this._freespinRound === 0;
    }

    protected startWinPresentation():void {
        const timeline:TimelineLite = new TimelineLite({paused : true, onComplete : () => this.finish()});
        this._scatterPositions.forEach((symbolId:number, reelId:number) => {
            timeline.add(this.getReelSymbolAnimation(reelId, symbolId), 0);
        });
        this._timeline = timeline;
        this._timeline.play();
    }

    private getReelSymbolAnimation(reelId:number, symbolId:number):TimelineLite {
        const timeline:TimelineLite = new TimelineLite();
        for(let i:number = 3; i < 6; i++) {
            if(i === symbolId) {
                timeline.add(this.getScatterSymbolAnimation(reelId, symbolId, false), 0);
            } else {
                timeline.add(Reels.getSymbol(reelId, i)!.changeState({
                    state : GameConfig.instance.SYMBOL_STATES.noWin!,
                    fadeInDuration : 0.1
                }), 0)
            }
        }

        return timeline;
    }

    private getScatterSymbolAnimation(reelId:number, symbolId:number, isAbort:boolean):Timeline {
        const symbol:PPScatterSymbol | null = <PPScatterSymbol>Reels.getSymbol(reelId, symbolId);
        if(symbol == null || !(symbol instanceof PPScatterSymbol)) {
            debugger;
            return new TimelineLite();
        }

        symbol.parent.addChild(symbol);
        return symbol.changeState({
            state : GameConfig.instance.SYMBOL_STATES.win,
            setStack : true,
            fadeInDuration : isAbort ? 0 : 0.1,
            frames : isAbort ? [-1, -1] : [0]
        })!;
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(this._timeline) {
            if(this._timeline.isActive()) {
                this._timeline.pause();
                this._timeline.kill();
            }
            this._timeline = null;
        }
        this._scatterPositions.forEach((symbolId:number, reelId:number) => {
            if(symbolId < 0) {
                return;
            }
            this.getScatterSymbolAnimation(reelId, symbolId, true);
        });
        // the next is fs intro so we don't need to reset the nowin symbols.
    }
}